import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { PostListType, ProfileInfoType } from "gnx-social-network-wcomponent";

@Component({
  selector: "app-social-user-profile",
  templateUrl: "./social-user-profile.page.html",
  styleUrls: ["./social-user-profile.page.scss"],
})
export class SocialUserProfilePage implements OnInit {
  sub: any;
  profileInfoType: ProfileInfoType;
  postType: PostListType; /*  = PostListType.ANOTHER_USER; */
  userInfoPath: string; /*  = 'user-info/56527715712363333'; */

  constructor(
    private route: ActivatedRoute,
    public languageService: LanguagesService
  ) {}
  ngOnInit() {
    this.sub = this.route.paramMap.subscribe((params) => {
      // Defaults to 0 if no query param provided.
      const userId = params.get("id");
      this.profileInfoType = ProfileInfoType.ANOTHER_USER;
      this.postType = PostListType.ANOTHER_USER;
      this.userInfoPath = `${params.get("path")}/${userId}`;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  get getTextIUPageSocialProfile() {
    return this.languageService.textsIU.page_social_profile;
  }
}
